<template>
  <article>
    <div class="c_single_movie">
      <div class="pt-3" :style="{ width: '100%', height: playerHeight + 'px' }">
        <video-player
          class="px-6"
          el="player"
          ref="player"
          :options="videoOptions"
          @play="play"
          @pause="pause"
          @ended="ended"
        ></video-player>
      </div>
    </div>
    <div class="detail">
      <p class="c_main_ttl">{{ contents.title }}</p>
      <p>{{ contents.description }}</p>
    </div>
    <div v-if="video.has_attachment || contents.video_attach">
      <div class="c_single_dl" v-if="loading">
        <div class="c_btn -gray c_single_dl_btn">
          <span class="icon-download"></span>
          ダウンロード中
          <div :class="{ c_load: loading }"></div>
        </div>
      </div>
      <div class="c_single_dl" v-else>
        <a class="c_btn c_single_dl_btn" @click="getAttachment">
          <span class="icon-download"></span>
          補助資料ダウンロード
        </a>
      </div>
    </div>
  </article>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer";
import { jc3CloudFrontDomain } from "@/../config.json";

export default {
  components: {
    VideoPlayer
  },
  props: {
    contents: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      video: {},
      windowWidth: window.innerWidth,
      timer: "",
      first: true,
      loading: false,
      intervalId: null
    };
  },
  mounted() {
    window.addEventListener("resize", this.calculateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateWindowWidth);
    this.stopProgressUpdate();
  },
  computed: {
    videoOptions() {
      return {
        source: `https://${jc3CloudFrontDomain}/${this.contents.key}`,
        poster: `https://${jc3CloudFrontDomain}/${this.contents.thumbnail_key}`,
        width: "100%",
        height: "100%",
        autoplay: false,
        watermark: {},
        hlsjsConfig: {
          xhrSetup: function(xhr) {
            // iPhoneでは動かない
            xhr.withCredentials = true;
          }
        }
      };
    },
    playerHeight: function() {
      return (this.playerWidth * 9) / 16;
    },
    playerWidth: function() {
      if (this.windowWidth > 1280) {
        return 1280;
      } else {
        return this.windowWidth;
      }
    },
    attachmentURL: function() {
      return `https://${jc3CloudFrontDomain}/${this.contents.video_attach}`;
    }
  },
  methods: {
    init() {
      if (this.contents.progress && this.contents.progress.current_position) {
        this.$refs.player.init(this.contents.progress.current_position);
      } else {
        this.$refs.player.init(0);
      }
    },
    getFileNameFromContentDisposition(disposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/; // 正規表現でfilenameを抜き出す
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        const fileName = matches[1].replace(/['"]/g, "");
        return decodeURI(fileName); // 日本語対応
      } else {
        return null;
      }
    },
    responseFileDownload(response, filename) {
      const url = URL.createObjectURL(new Blob([response.data]), {
        type: response.headers["content-type"]
      });
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    },
    getAttachment() {
      if (this.contents.video_type === 1) {
        this.loading = true;
        this.$authAxios
          .get(this.attachmentURL, {
            responseType: "blob"
          })
          .then(response => {
            const filename = this.getFileNameFromContentDisposition(
              response.headers["content-disposition"]
            );
            this.responseFileDownload(response, filename);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        window.open(this.attachmentURL);
      }
    },
    calculateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    play() {
      this.startProgressUpdate();
    },
    pause() {
      this.stopProgressUpdate();
    },
    ended() {
      this.stopProgressUpdate();
      this.sendProgress(1);
    },
    // 進捗を送信する
    sendProgress(finish = false) {
      const currentTime = this.$refs.player.player.getCurrentTime();
      const duration = this.$refs.player.player.getDuration();
      if (currentTime && duration) {
        const progressData = {
          current_position: finish ? 0 : currentTime,
          progress_ratio: finish ? 1.0 : currentTime / duration
        };
        this.$authAxios
          .post(`/api/contents/${this.contents.id}/progress/`, progressData)
          .catch(error => {
            console.error("Error sending progress:", error);
          });
      }
    },
    // 5秒間隔で進捗を送信する
    startProgressUpdate() {
      this.intervalId = setInterval(() => {
        this.sendProgress();
      }, 5000);
    },
    // 進捗の更新を停止する
    stopProgressUpdate() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  }
};
</script>

<style scoped>
.detail {
  margin-top: 20px;
}
.c_main_ttl {
  text-align: start;
}
</style>
